export enum CompanyObjectivePeriodStatus {
  Past = 'past',
  Active = 'active',
  Future = 'future',
}

export const COMPANY_OBJECTIVE_PERIOD_STATUS_LABELS: Record<CompanyObjectivePeriodStatus, string> = {
  [CompanyObjectivePeriodStatus.Past]: 'Pasado',
  [CompanyObjectivePeriodStatus.Active]: 'Activo',
  [CompanyObjectivePeriodStatus.Future]: 'Futuro',
};
